import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { ConfirmModal } from 'stories/components'

const ConfirmDialog = ({ show, proceed, confirmation, options, childLevel }: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <ConfirmModal
      isOpen={show}
      onOk={() => {
        options.onOk ? proceed(options.onOk()) : proceed(true as any)
      }}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      content={confirmation}
      options={options}
      childLevel={childLevel}
    />
  )
}

const confirmDlg = confirmable(ConfirmDialog)

const createConfirm = createConfirmation(confirmDlg)

export const confirm = (content: string | JSX.Element, options: Record<string, any> = {}, childLevel: number = 1) =>
  createConfirm({ confirmation: content, options, childLevel })

export const confirmOverrideErrors = (title: string, errors: string[], canOverride: boolean = false) => {
  const contentElement = (
    <div className="text-left bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-[14px] mb-4">
      <div className="font-semibold text-[14.5px] mb-2">{title}</div>
      {errors.map((error: string) => (
        <div className="mt-1">
          <div className="ml-4">- {error}</div>
        </div>
      ))}
    </div>
  )

  if (canOverride) return confirm(contentElement, { titleYes: 'Override', titleNo: 'Close' })

  return confirm(contentElement, { titleYes: false, titleNo: 'Close' })
}
